<div *ngIf="user$ | async; let user">
  <div *ngIf="((showNotificationBanner() | async) ?? false) && !user.isNotificationBannerRead" class="alert alert-info d-flex justify-content-between align-items-center">
    <div class="mx-auto">
      Evidence on Cloud&#8482; is now part of Wrap Technologies, Inc. Visit <b><a target="_blank" href="https://www.wrap.com" rel="noopener noreferrer">Wrap.com</a></b>
    </div>
    <a (click)="updateUserNotificationBannerRead(user.uid)"> <shared-ui-icons-icon [iconName]="iconType.Xmark"></shared-ui-icons-icon></a>
  </div>
</div>
